import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Button from "./Button.js";
import PlusMinButtons from "./PlusMinButtons.js";
import Row from "./Row.js";
import TextInput from "./TextInput.js";
import * as Styles from "../../constants/StyleConstants";

class RepeatingRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isHovered: false };
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    componentWillUpdate(nextProps) {
        if (this.props != nextProps)
            this.setState({ isHovered: false });
    }

    onMouseEnter(e) {
        this.setState({ isHovered: true });
    }

    onMouseLeave(e) {
        this.setState({ isHovered: false });
    }

    render() {

        const { children, onAddClick, onRemoveClick, isDisabled, isMinButtonEnabled, isPlusButtonEnabled } = this.props;

        const minButtonWrapperProps = {
            className: "o-col-1",
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
            style: { marginTop: "15px" }
        };

        const plusButtonWrapperProps = {
            className: "o-col-1",
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
            style: { marginTop: "15px" }
        };

        const plusMinusButtonsDisabled = !isMinButtonEnabled && !isPlusButtonEnabled ? "o-col-12" : "o-col-10";

        const containerProps = {
            className: plusMinusButtonsDisabled,
            style: this.state.isHovered ? Styles.highlightedRowContainerStyle : Styles.rowContainerStyle
        };

        return (<Row>
            <div {...containerProps}>
                {children}
            </div>
            {isMinButtonEnabled ? <div {...minButtonWrapperProps}>
                <Button className="c-button--input min" onClick={onRemoveClick} disabled={isDisabled}>-</Button>
            </div> : null}
            {isPlusButtonEnabled ? <div {...plusButtonWrapperProps}>
                <Button className="c-button--input plus" onClick={onAddClick} disabled={isDisabled}>+</Button>
            </div> : null}
        </Row>);
    }
}

RepeatingRow.propTypes = {
    children: PropTypes.node,
    onAddClick: PropTypes.func,
    onRemoveClick: PropTypes.func,
    onChange: PropTypes.func,
    isDisabled: PropTypes.bool,
    isMinButtonEnabled: PropTypes.bool,
    isPlusButtonEnabled: PropTypes.bool
};

RepeatingRow.defaultProps = {
    onAddClick: function () { },
    onRemoveClick: function () { },
    isDisabled: false,
    isMinButtonEnabled: true,
    isPlusButtonEnabled: true
};

export default RepeatingRow;